/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgServerOrigin = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.59 21.77a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM58 28.64V15.79l-2-2H8l-2 2v12.85l2 2h48l2-2ZM10 17.79h44v8.85H10v-8.85Zm39.5 21.46a2.09 2.09 0 1 0 0 4.179 2.09 2.09 0 0 0 0-4.179Zm-11.4 7H10v-8.89h28l2-4H8l-2 2v12.85l2 2h32.11l-2.01-3.96Zm20.22-5a8.82 8.82 0 1 0-17.64 0c0 5.54 6.44 14 7.17 14.9h3.14c.75-.99 7.33-9.42 7.33-14.97v.07Zm-4 0c0 2.53-2.57 7-4.88 10.3-2.25-3.29-4.76-7.76-4.76-10.3a4.82 4.82 0 1 1 9.64 0Z"
}));

export default SvgServerOrigin;